import React, { useState } from 'react';
import './Input.css';

const Input = ({
  type = 'text',
  placeholder,
  value,
  onChange,
  icon: Icon,
  showPasswordToggle = false,
  error,
  success = false,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const inputType = type === 'password' && showPassword ? 'text' : type;

  // Build class names dynamically
  const containerClasses = ['input-container'];
  if (isFocused) containerClasses.push('focused');
  if (error) containerClasses.push('error');
  if (success && !error) containerClasses.push('success');

  const classString = containerClasses.join(' ');

  // Debug logging for password field
  if (type === 'password' && value) {
    console.log('Password field - Success:', success, 'Error:', error, 'Value length:', value.length, 'Classes:', classString);
  }

  return (
    <div className="input-wrapper">
      <div className={classString}>
        {Icon && (
          <div className="input-icon">
            <Icon size={20} color="#6E7079" />
          </div>
        )}
        
        <input
          type={inputType}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="input-field"
          {...props}
        />
        
        {showPasswordToggle && (
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            <img 
              src="/img/svg/fi_eye-off.svg" 
              alt={showPassword ? "Hide password" : "Show password"} 
              width="16" 
              height="16"
              style={{ 
                filter: `brightness(0) saturate(100%) invert(42%) sepia(8%) saturate(1015%) hue-rotate(202deg) brightness(95%) contrast(86%)`,
                opacity: showPassword ? 0.7 : 1
              }}
            />
          </button>
        )}
      </div>
      {error && <div className="input-error">{error}</div>}
    </div>
  );
};

// Email Icon Component
export const EmailIcon = ({ size = 20, color = "#6E7079" }) => (
  <img 
    src="/img/svg/message.svg" 
    alt="Email" 
    width={size} 
    height={size}
    style={{ filter: `brightness(0) saturate(100%) invert(42%) sepia(8%) saturate(1015%) hue-rotate(202deg) brightness(95%) contrast(86%)` }}
  />
);

// Lock Icon Component
export const LockIcon = ({ size = 20, color = "#6E7079" }) => (
  <img 
    src="/img/svg/lock.svg" 
    alt="Lock" 
    width={size} 
    height={size}
    style={{ filter: `brightness(0) saturate(100%) invert(42%) sepia(8%) saturate(1015%) hue-rotate(202deg) brightness(95%) contrast(86%)` }}
  />
);

export default Input;
